import { createAction } from '../../../../store.model';
import { TaskItem } from '../../../core';
import { ActionType } from '../task-list-dialog.action';

export interface ReceiveItems {
    tasks: TaskItem[] | null;
    append: boolean | null;
}

export const receiveTasks = createAction<ActionType, ReceiveItems>(
    ActionType.TC__TL__RECEIVE_ITEMS,
);
